'use client'

import { AppBar, Box, Container, Toolbar } from '@mui/material'
import { Menu } from './menu'
import { Footer } from './Footer'
import { MenuWrapper } from './Menu.styles'
import { useTheme, alpha } from '@mui/material/styles'
import { useNavigation } from '@/contexts/NavigationContext'

export function LayoutContent({ children }: { children: React.ReactNode }) {
  const theme = useTheme();
  const { servicesRef, industriesRef, aboutRef } = useNavigation();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <MenuWrapper>
        <AppBar
          position="fixed"
          color="default"
          elevation={1}
          sx={{
            border: 'none',
            background: alpha(theme.palette.primary.main, 0.8),
            boxShadow: 'none',
            backdropFilter: 'blur(6px)',
          }}
        >
          <Toolbar>
            <Menu
              servicesRef={servicesRef}
              industriesRef={industriesRef}
              aboutRef={aboutRef}
            />
          </Toolbar>
        </AppBar>
      </MenuWrapper>
      <Toolbar />
      <Container 
        component="main" 
        maxWidth={false}
        sx={{ 
          flex: 1, 
          pb: 4,
          px: { xs: 2, sm: 3, md: 4 },
          maxWidth: {
            xs: '100%',
            sm: '100%',
            md: '100%',
            lg: '1200px',
            xl: '1600px'
          }
        }}
      >
        {children}
      </Container>
      <Footer />
    </Box>
  )
} 